var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 18,
    x2: 36,
    y2: 18
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#704FFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1428,
    style: {
      stopColor: "#695CFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4168,
    style: {
      stopColor: "#5E6FFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6992,
    style: {
      stopColor: "#577AF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#557EF8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M6.755,9.016h1.137v1.081H10.1v-1.1H9.021V7.859h1.069V6.741H9.016V5.604h1.078V4.527H7.868 v1.076H6.732V4.535H4.532v1.083H5.61v1.149H4.528v1.117h1.075v1.136H4.523v1.074h2.231V9.016z M6.773,6.761h1.079v1.091H6.773 V6.761z M6.72,14.59v-1.063H5.645v1.063H6.72z M8.973,14.594V13.52H7.911v1.074H8.973z M6.767,23.981 c0.473,0.445,0.945,0.891,1.465,1.38c-1.002,0.991-1.981,1.961-2.952,2.921c0.25,0.26,0.491,0.511,0.679,0.707 c1.256-1.257,2.5-2.501,3.747-3.747c-0.2-0.209-0.436-0.456-0.705-0.738c1.086-0.241,2.101-0.466,3.204-0.711 c-0.244,1.099-0.472,2.126-0.727,3.273c-0.295-0.339-0.523-0.6-0.709-0.813c-2.036,2.036-4.027,4.027-6,6 c0.208,0.222,0.445,0.475,0.724,0.772c1.745-1.745,3.471-3.472,5.277-5.279c0.444,0.488,0.881,0.968,1.361,1.495 c0.519-2.337,1.02-4.589,1.535-6.91c-2.325,0.517-4.581,1.019-6.837,1.52C6.809,23.896,6.788,23.939,6.767,23.981z M14.599,13.523 h-1.074v1.072h1.074V13.523z M30.345,3.402h-1.072v1.065h1.072V3.402z M4.465,13.532H3.404v1.075h1.061V13.532z M35.585,16.893 c-0.319-1.226-0.909-2.324-1.664-3.34c-0.102-0.137-0.17-0.336-0.17-0.506c-0.009-3.841-0.019-7.682,0.005-11.523 c0.004-0.707-0.18-1.23-0.849-1.524H0.844C0.457,0.176,0.176,0.457,0,0.844v18.563c0.295,0.667,0.815,0.853,1.524,0.849 c4.591-0.023,9.182-0.012,13.774-0.012h0.428c0.593,4.866,3.218,7.959,7.899,9.354V36h1.125v-3.919H27V36h1.125v-6.444 c1.194-0.291,2.306-0.74,3.31-1.426c2.602-1.779,4.115-4.227,4.496-7.365c0.013-0.103,0.046-0.203,0.069-0.305v-1.547 C35.864,18.24,35.758,17.557,35.585,16.893z M1.138,19.114V1.137h31.463v10.956c-3.225-2.583-6.793-3.323-10.62-1.716 c-3.812,1.601-5.804,4.644-6.239,8.737H1.138z M26.982,30.92h-2.224v-1.141h2.224V30.92z M33.451,24.558 c-2.189,3.381-6.359,4.929-10.198,3.746c-4.048-1.247-6.23-4.89-6.346-8.038h1.105c0.289,2.741,1.602,4.854,3.984,6.254 c1.694,0.995,3.538,1.269,5.459,0.875c3.844-0.789,6.605-4.423,6.266-8.239h-1.08c0.081,2.572-0.882,4.667-3.029,6.146 c-1.319,0.908-2.808,1.28-4.404,1.11c-3.659-0.388-5.903-3.431-6.042-6.161h4.995V19.14H19.14 c0.178-1.778,0.893-3.242,2.174-4.421c1.274-1.173,2.796-1.755,4.538-1.799v-1.061c-3.089-0.22-7.485,2.461-7.85,7.246h-1.114 c0.093-1.447,0.513-2.77,1.236-4c3.006-5.116,10.156-5.95,14.236-1.666c0.191,0.201,0.28,0.398,0.277,0.679 c-0.014,1.276-0.006,2.551-0.006,3.851h1.1v-2.558C35.1,17.537,35.503,21.388,33.451,24.558z M25.342,20.224h1.073v-1.066h-1.073 V20.224z M12.406,16.848h2.2v-1.064h-2.2V16.848z M11.278,5.6h1.063V4.519h-1.063V5.6z M27.594,20.221h1.068v-1.074h-1.068V20.221 z M3.404,16.849h7.823v-1.068H3.404V16.849z M10.158,14.595h1.075v-1.071h-1.075V14.595z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrIcon3);
export default __webpack_public_path__ + "static/media/pr-icon-3.57218608bd6c6517d162e0460ab000a1.svg";
export { ForwardRef as ReactComponent };